// src/pages/micuenta/Favorites.jsx
import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./favoritos.css";

function Favoritos() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);

  if (!user) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  useEffect(() => {
    const storedFavs = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(storedFavs);
  }, []);

  const handleRemoveFavorite = (favId) => {
    if (window.confirm("¿Deseas eliminar este recurso de tus favoritos?")) {
      setFavorites((prev) => {
        const updated = prev.filter((fav) => fav.id !== favId);
        localStorage.setItem("favorites", JSON.stringify(updated));
        return updated;
      });
    }
  };

  const handleBack = () => {
    navigate("/mi-cuenta");
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        <h2 className="favorites-title">Tus favoritos</h2>

        {favorites.length === 0 ? (
          <p>No tienes favoritos guardados.</p>
        ) : (
          <div className="favorites-table">
            <div className="table-header">
              <span>Categoría</span>
              <span>Recurso</span>
              <span>Eliminar</span>
              <span>Ver Completo</span>
            </div>
            {favorites.map((fav) => (
              <div className="table-row" key={fav.id}>
                <span>{fav.category}</span>
                <span>{fav.resource}</span>
                <span>
                  <button
                    className="remove-fav-btn"
                    onClick={() => handleRemoveFavorite(fav.id)}
                  >
                    Eliminar
                  </button>
                </span>
                <span>
                  <a
                    href={fav.link}
                    target="_blank"
                    rel="noreferrer"
                    className="ver-completo-link"
                  >
                    Ver
                  </a>
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Favoritos;